import { lazy, Suspense } from 'react';
import { Outlet, createRoute } from '@tanstack/react-router';

import DashboardLayout from 'src/layouts/dashboard';

import AppAuthGuard from 'src/components/auth/app-auth-guard';
import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { rootRoute } from './root';

const ProducerDetails = lazy(() => import('src/sections/producer/producer-details/view'));

// Producer routes — standalone read-only producer page (viewable by any authenticated user).
// No ownership/permission guard here: non-owners must be able to view a producer's profile.
const producersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'producer',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AppAuthGuard>
  ),
});

const producerDetailsRoute = createRoute({
  getParentRoute: () => producersRoute,
  path: '$producerPageId',
  component: ProducerDetails,
});

export const producerRouteTree = producersRoute.addChildren([producerDetailsRoute]);
